import logger from '../../utils/logger';
import { authChannel } from './authChannel';
import { performLogout } from './tokenManagger';




export const requestLogout = () => {

 logger.debug('📤 enviando LOGOUT')

  performLogout() // 👈 ESTA pestaña
 
  authChannel.postMessage({ type: 'LOGOUT' });
}